import type { RootState } from "../appState";
import { filterConfigurations, type SavedCoilConfiguration } from "../../web-app";

export const PAGE_SIZE = 6;

export function selectFilteredConfigurations(state: RootState) {
  const { items, search, statusFilter } = state.coilConfigurator.configurations;
  return filterConfigurations(items, search, statusFilter);
}

export function selectPaginatedConfigurations(state: RootState) {
  const filtered = selectFilteredConfigurations(state);
  const page = state.coilConfigurator.configurations.page;
  const start = (page - 1) * PAGE_SIZE;
  return filtered.slice(start, start + PAGE_SIZE);
}

export function selectSelectedConfiguration(state: RootState) {
  const { items, selectedId } = state.coilConfigurator.configurations;
  return items.find((item: SavedCoilConfiguration) => item.id === selectedId) ?? null;
}

export function selectCatalogueDirty(state: RootState): boolean {
  const { active, saved } = state.coilConfigurator.catalogue;
  return JSON.stringify(active) !== JSON.stringify(saved);
}

export function selectAssumptionsDirty(state: RootState): boolean {
  const { active, saved } = state.coilConfigurator.assumptions;
  return JSON.stringify(active) !== JSON.stringify(saved);
}
